import React, { useState, useEffect } from 'react';
import './CountdownButton.css';
import Cookies from 'js-cookie';

const CountdownButton = ({ initialTime, onClick }) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        setTimeLeft(initialTime);
        setIsDisabled(true);
    }, [initialTime]);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
                if (Cookies.get('cookieConsent') === 'accepted') {
                    Cookies.set('offsetSecond', Number(timeLeft), { expires: Number(timeLeft) / 86400 });
                } else {
                    //沒用Cookie的路線暫時不處理
                }
            }, 1000);

            return () => clearInterval(timer);
        } else {
            setIsDisabled(false);
        }
    }, [timeLeft]);

    const handleClick = () => {

        if (onClick) {
            onClick();
            setTimeLeft(initialTime); // 重置倒數計時
            setIsDisabled(true);
        }
    };

    return (
        <button
            type='button' name='resend' disabled={isDisabled}
            id='resend' className='btn countdown-button' onClick={handleClick}>

            重新發送驗證碼{isDisabled ? `(${timeLeft}秒後可以重發)` : ''}
        </button>
    );
};



export default CountdownButton;
